import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "desktop-other-actions-content" }
const _hoisted_2 = ["onClick"]
const _hoisted_3 = { class: "desktop-other-actions-text" }

import { Message } from "@/store/chats/types";
import { IconType } from "@/types/icons";
import { useGetMessageHandlers } from "@/composables";
import { useI18n } from "vue-i18n";
import Icon from "@/components/icons/Icon/Icon.vue";
import { computed } from "vue";

interface DesktopOtherActions {
  message: Message;
  isMine: boolean;
}

interface Emits {
  (e: "closeActions"): void;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'DesktopOtherActions',
  props: {
    message: {},
    isMine: { type: Boolean }
  },
  emits: ["closeActions"],
  setup(__props: any, { emit: __emit }) {

const emit = __emit;
const { t } = useI18n();
const { handleModifyMessage, handleRemoveMessage, openForwardMessageDialog } =
  useGetMessageHandlers();
const props = __props;

const closeActions = () => {
  emit("closeActions");
};

const removeMessage = (e: MouseEvent) => {
  e.stopPropagation();
  handleRemoveMessage(props.message);
  closeActions();
};

const modifyMessage = (e: MouseEvent) => {
  e.stopPropagation();
  handleModifyMessage(props.message);
  closeActions();
};
const forwardMessage = (e: MouseEvent) => {
  e.stopPropagation();
  openForwardMessageDialog(props.message);
  closeActions();
};

const items = computed(() => {
  const items = [];
  if (props.isMine) {
    items.push(
      {
        icon: IconType.REMOVE_MESSAGE,
        text: t("chat.chatContainer.messages.controls.delete"),
        action: removeMessage,
      },
      {
        icon: IconType.EDIT,
        text: t("chat.chatContainer.messages.controls.modify"),
        action: modifyMessage,
      },
    );
  }
  items.push({
    icon: IconType.FORWARD_MESSAGE,
    text: t("chat.chatContainer.messages.controls.forward"),
    action: forwardMessage,
  });
  return items;
});

return (_ctx: any,_cache: any) => {
  const _directive_click_outside = _resolveDirective("click-outside")!

  return _withDirectives((_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["desktop-other-actions", { isMine: _ctx.isMine }])
  }, [
    _createElementVNode("div", _hoisted_1, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(items.value, (item) => {
        return (_openBlock(), _createElementBlock("div", {
          key: item.icon,
          class: "desktop-other-actions-item",
          onClick: item.action
        }, [
          _createVNode(Icon, {
            icon: item.icon,
            class: "icon"
          }, null, 8, ["icon"]),
          _createElementVNode("span", _hoisted_3, _toDisplayString(item.text), 1)
        ], 8, _hoisted_2))
      }), 128))
    ])
  ], 2)), [
    [_directive_click_outside, closeActions]
  ])
}
}

})